
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0.1 0.66 24 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.844 20.43v-1.68a3.36 3.36 0 00-3.359-3.358H8.767a3.36 3.36 0 00-3.359 3.359v1.68M15.486 8.673a3.36 3.36 0 11-6.719 0 3.36 3.36 0 016.719 0z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.127 23.172c6.145 0 11.127-4.982 11.127-11.127C23.254 5.9 18.272.918 12.127.918 5.982.918 1 5.9 1 12.045c0 6.145 4.982 11.127 11.127 11.127z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    